import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleShipping() {
  return <ArticleTemplate slug="sugargoo-shipping-cost" />;
}